import jQuery from 'jquery';
import AOS from 'aos';
import 'slick-carousel/slick/slick.min.js';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Import all of Bootstrap’s JS
import * as bootstrap from 'bootstrap';


jQuery(function ($) {    
    /***********************************************************************/
    /************************ LOAD POSTS ***********************************/
    /***********************************************************************/

    console.log('news.js loaded');

    $('.cat-nav').on('click', function(e) {
        if ($(window).width() <= 767) {
        $(this).toggleClass('show-dropdown');
        }
    });

    $(document).on('click', function(e) {
        var container = $('.cat-nav');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('show-dropdown');
        }
    });

    const $loader = $('#loader');
    const $postsContainer = $('#posts-container');
    const $paginationWrap = $('.ajax-pagination');

    function getPagedFromUrl(url) {
        if (!url) return 1;
        const match = url.match(/[?&]paged=(\d+)/);
        return match ? parseInt(match[1], 10) : 1;
    }

    function showLoader() {
        $loader.show();
        $postsContainer.addClass('loading');
    }

    function hideLoader() {
        $loader.hide();
        $postsContainer.removeClass('loading');
    }

    function bindPaginationLinks(categorySlug) {
        $paginationWrap.find('a').off('click.news').on('click.news', function(e){
            e.preventDefault();
            const href = $(this).attr('href');
            const paged = getPagedFromUrl(href) || 1;
            loadPosts(categorySlug, paged, true);
        });
    }

    function loadPosts(categorySlug = '', paged = 1, pushState = false) {
        showLoader();

        $.ajax({
            url: ajax_object.ajaxurl,
            type: 'POST',
            data: {
                action: 'load_posts_by_category',
                category_slug: categorySlug,
                paged: paged,
                nonce: ajax_object.nonce,
            },
            success: function(response) {
                hideLoader();

                let handled = false;

                // Try to parse JSON response from server
                try {
                    const parsed = (typeof response === 'string') ? JSON.parse(response) : response;

                    if (parsed && parsed.success && parsed.data) {
                        $postsContainer.html(parsed.data.content || '');
                        $paginationWrap.html(parsed.data.pagination || '');
                        handled = true;
                    }
                } catch (err) {
                    // ignore, maybe HTML returned
                }

                // If not JSON, but response looks like HTML, use it
                if (!handled && typeof response === 'string' && response.trim().length && response.trim().indexOf('<') !== -1) {
                    $postsContainer.html(response);
                    $paginationWrap.html('');
                    handled = true;
                }

                if (!handled) {
                    console.warn('news.js: no usable content returned from load_posts_by_category');
                }

                // Bind pagination links inside the updated pagination area
                bindPaginationLinks(categorySlug);

                // Update URL
                if (pushState) {
                    let newURL = window.location.pathname;
                    const params = [];
                    if (categorySlug) params.push('category=' + encodeURIComponent(categorySlug));
                    if (paged && paged > 1) params.push('paged=' + paged);
                    if (params.length) newURL += '?' + params.join('&');
                    window.history.pushState({paged: paged, category: categorySlug}, '', newURL);
                }
            },
            error: function(err) {
                hideLoader();
                console.error('news.js AJAX error', err);
            }
        });
    }

    // Bind pagination links that might be server-rendered on load
    bindPaginationLinks('');

    // Handle back/forward navigation
    window.addEventListener('popstate', function(e){
        const state = e.state || {};
        const paged = state.paged || getPagedFromUrl(window.location.href) || 1;
        const category = state.category || '';
        loadPosts(category, paged, false);
    });

    // Get the category slug and pagination page from URL on initial page load
    var urlParams = new URLSearchParams(window.location.search);
    var categorySlug = urlParams.get('category') || '';
    var paged = urlParams.get('paged') || 1;

    $('.category-link').on('click', function(e){
        e.preventDefault();
        $('.category-link').removeClass('active');
        $(this).addClass('active');
        var categorySlug = $(this).data('category');
        loadPosts(categorySlug, 1, true);
    });

    // Load the first page with AJAX pagination by default
    loadPosts(categorySlug, paged);
});